import { MessageCircle } from "lucide-react";

export default function WhatsAppAssistant() {
  const message = "Hello Jisedai, I would like to learn more about your products and services.";

  return (
    <a
      href={`https://wa.me/254777748910?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Jisedai on WhatsApp"
      className="group fixed bottom-5 right-5 z-[60] flex items-center gap-3 rounded-full border border-white/30 bg-[#45695a] px-4 py-3 text-sm font-bold text-white shadow-xl shadow-[#45695a]/25 transition hover:-translate-y-1 hover:bg-[#344f42] focus:outline-none focus:ring-4 focus:ring-[#d6e85c]/50"
    >
      <span className="hidden max-w-0 overflow-hidden whitespace-nowrap transition-all duration-300 group-hover:max-w-40 sm:inline-block sm:group-hover:max-w-40">
        Ask Jisedai
      </span>
      <MessageCircle size={22} aria-hidden="true" className="text-[#d6e85c]" />
    </a>
  );
}
